<div class="container mt-4">

  <!-- Filters (+ Window Days) + counts -->
  <div class="card mb-3">
    <div class="card-body">
      <div class="row g-3 align-items-end">

        <!-- ✅ Window (days) row inside the same card, above other inputs -->
        <div class="col-12">
          <div class="row g-2 align-items-end">
            <div class="col-12 col-sm-auto">
              <label class="form-label mb-1">Window (days):</label>
              <input type="number" class="form-control" [(ngModel)]="days" min="30" step="1" />
            </div>
            <div class="col-12 col-sm-auto">
              <label class="form-label mb-1 d-none d-sm-block">&nbsp;</label>
              <button class="btn btn-primary w-100" (click)="reloadAll()">Reload</button>
            </div>
            <div class="col-12 col-sm d-flex align-items-center">
              <span class="text-muted ms-sm-auto" *ngIf="loading">Loading…</span>
            </div>
          </div>
        </div>

        <!-- Inputs row (stacks on mobile) -->
        <div class="col-12 col-sm-6 col-md-auto">
          <label class="form-label mb-1">Cash In/Day (min)</label>
          <input type="number" class="form-control" step="0.01"
                 [(ngModel)]="pageFilter.cashInPerDayMin" (input)="applyAllFilters()">
        </div>

        <div class="col-12 col-sm-6 col-md-auto">
          <label class="form-label mb-1">Cash In/Day (max)</label>
          <input type="number" class="form-control" step="0.01"
                 [(ngModel)]="pageFilter.cashInPerDayMax" (input)="applyAllFilters()">
        </div>

        <div class="col-12 col-sm-6 col-md-auto">
          <label class="form-label mb-1">Sales Rep</label>
          <input class="form-control"
                 [(ngModel)]="pageFilter.salesRepName" (input)="applyAllFilters()"
                 placeholder="e.g. Andy Vasvani">
        </div>

        <div class="col-12 col-sm-6 col-md-auto">
          <label class="form-label mb-1">State</label>
          <input class="form-control"
                 [(ngModel)]="pageFilter.state" (input)="applyAllFilters()"
                 placeholder="e.g. GA">
        </div>

        <div class="col-12 col-sm-6 col-md-auto">
          <label class="form-label mb-1">Location Name</label>
          <input class="form-control"
                 [(ngModel)]="pageFilter.locationName" (input)="applyAllFilters()"
                 placeholder="e.g. Lucky You">
        </div>

        <!-- Counts -->
        <div class="col-12 col-md-auto d-flex align-items-center gap-3">
          <span class="badge bg-primary fs-6">
            Boards: {{ boardCount }}
          </span>
          <span class="badge bg-info fs-6">
            Locations: {{ locationCount }}
          </span>
        </div>

        <!-- Actions (stack on mobile, inline on md+) -->
        <div class="col-12 col-md ms-md-auto">
          <div class="row g-2">
            <div class="col-12 col-md-auto">
              <button class="btn btn-outline-secondary w-100"
                      (click)="pageFilter={cashInPerDayMin:null,cashInPerDayMax:null,salesRepName:'',state:'',locationName:''}; applyAllFilters();">
                Clear Page Filters
              </button>
            </div>
            <div class="col-12 col-md-auto">
              <button class="btn btn-success btn-sm w-100" (click)="exportFilteredBoardsCsv()">
                Export Boards (Filtered CSV)
              </button>
            </div>
            <div class="col-12 col-md-auto">
              <button class="btn btn-success btn-sm w-100" (click)="exportFilteredLocationsCsv()">
                Export Locations (Filtered CSV)
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>


  <!-- Board Performance -->
  <div class="card mb-4">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h5 class="mb-0">Board Performance</h5>
      <div class="d-flex gap-2">
        <button class="btn btn-outline-primary btn-sm" (click)="showBoardStats = !showBoardStats">
          {{ showBoardStats ? 'Hide' : 'Show' }}
        </button>
      </div>
    </div>

    <div class="card-body" *ngIf="showBoardStats">
      <div *ngIf="!loading && originalBoardStats.length === 0" class="text-muted">No data.</div>

      <div *ngIf="originalBoardStats.length > 0" class="table-responsive">
        <table class="table table-striped table-bordered align-middle">
          <thead class="bg-dark text-white">
            <tr>
              <th style="width:48px;"></th>
              <th>Category</th>
              <th>Asset Tag</th>
              <th>Location</th>
              <th>City</th>
              <th>State</th>
              <th>Sales Rep</th>
              <th>Days Active</th>
              <th>Cash In</th>
              <th>Cash Out</th>
              <th>Net</th>
              <th>$/Day</th>
              <th>Compared $/Day</th>
              <th>Net/Day</th>
            </tr>
            <tr class="bg-light text-dark">
              <th></th>
              <th><input class="form-control" [(ngModel)]="filtersBoard.category" (input)="applyBoardFilters()" placeholder="Filter" /></th>
              <th><input class="form-control" [(ngModel)]="filtersBoard.assetTag" (input)="applyBoardFilters()" placeholder="Filter" /></th>
              <th><input class="form-control" [(ngModel)]="filtersBoard.locationName" (input)="applyBoardFilters()" placeholder="Filter" /></th>
              <th><input class="form-control" [(ngModel)]="filtersBoard.city" (input)="applyBoardFilters()" placeholder="Filter" /></th>
              <th><input class="form-control" [(ngModel)]="filtersBoard.state" (input)="applyBoardFilters()" placeholder="Filter" /></th>
              <th><input class="form-control" [(ngModel)]="filtersBoard.salesRepName" (input)="applyBoardFilters()" placeholder="Filter" /></th>
              <th colspan="7"></th>
            </tr>
          </thead>

          <tbody>
            <ng-container *ngFor="let stat of boardStats; trackBy: trackByAssetTag">
              <!-- parent row -->
              <tr>
                <td>
                  <button class="btn btn-sm btn-outline-secondary"
                          (click)="toggleBoard(stat.assetTag)">
                    {{ expandedBoards.has(stat.assetTag) ? '▾' : '▸' }}
                  </button>
                </td>
                <td>{{ stat.performanceCategory }}</td>
                <td>{{ stat.assetTag }}</td>
                <td>{{ stat.locationName }}</td>
                <td>{{ stat.city }}</td>
                <td>{{ stat.state }}</td>
                <td>{{ stat.salesRepName }}</td>
                <td>{{ stat.daysActive }}</td>
                <td>{{ stat.totalCashIn | number }}</td>
                <td>{{ stat.totalCashOut | number }}</td>
                <td>{{ stat.totalNet | number }}</td>
                <td>{{ stat.cashInPerDay | number:'1.2-2' }}</td>
                <td>{{ stat.comparisonAverage | number:'1.2-2' }}</td>
                <td>{{ stat.netPerDay | number:'1.2-2' }}</td>
              </tr>

              <!-- child history row -->
              <tr *ngIf="expandedBoards.has(stat.assetTag)">
                <td colspan="14">
                  <div *ngIf="loadingBoardSegs.has(stat.assetTag)" class="text-muted">Loading history…</div>

                  <ng-container *ngIf="!loadingBoardSegs.has(stat.assetTag)">
                    <div *ngIf="(boardSegs[stat.assetTag] || []).length === 0" class="text-muted">No reads in this window.</div>

                    <div *ngIf="(boardSegs[stat.assetTag] || []).length > 0" class="table-responsive">
                      <table class="table table-sm table-bordered mb-2">
                        <thead class="table-secondary">
                          <tr>
                            <th>Seg #</th>
                            <th>Date</th>
                            <th>Total Cash In</th>
                            <th>Total Cash Out</th>
                            <th>Total Net</th>
                            <th>Days Active</th>
                            <th>Board Count</th>
                            <th>Cash In/Day</th>
                            <th>Net/Day</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let s of boardSegs[stat.assetTag]">
                            <td>{{ s.segIdx }}</td>
                            <td>{{ s.segStart }} – {{ s.segEnd }}</td>
                            <td>{{ s.cashIn | number }}</td>
                            <td>{{ s.cashOut | number }}</td>
                            <td>{{ s.net | number }}</td>
                            <td>{{ s.spanDays }}</td>
                            <td>1</td>
                            <td>{{ (s.spanDays ? s.cashIn / s.spanDays : 0) | number:'1.2-2' }}</td>
                            <td>{{ (s.spanDays ? s.net    / s.spanDays : 0) | number:'1.2-2' }}</td>
                          </tr>

                          <tr class="table-light" *ngIf="boardSegs[stat.assetTag] as segs">
                            <ng-container *ngIf="sumSegments(segs) as t">
                              <td colspan="2"><strong>Totals</strong></td>
                              <td><strong>{{ t.cashIn | number }}</strong></td>
                              <td><strong>{{ t.cashOut | number }}</strong></td>
                              <td><strong>{{ t.net | number }}</strong></td>
                              <td><strong>{{ t.spanDays }}</strong></td>
                              <td><strong>1</strong></td>
                              <td><strong>{{ (t.spanDays ? t.cashIn / t.spanDays : 0) | number:'1.2-2' }}</strong></td>
                              <td><strong>{{ (t.spanDays ? t.net   / t.spanDays : 0) | number:'1.2-2' }}</strong></td>
                            </ng-container>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </ng-container>
                </td>
              </tr>

            </ng-container>
            <tr *ngIf="!loading && boardStats.length === 0">
              <td colspan="14" class="text-muted">No matches — clear or change filters.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Location Performance -->
  <div class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h5 class="mb-0">Location Performance</h5>
      <div class="d-flex gap-2">
        <button class="btn btn-outline-primary btn-sm" (click)="showLocationStats = !showLocationStats">
          {{ showLocationStats ? 'Hide' : 'Show' }}
        </button>
      </div>
    </div>

    <div class="card-body" *ngIf="showLocationStats">
      <div *ngIf="!loading && locationStats.length === 0" class="text-muted">No data.</div>

      <div *ngIf="locationStats.length > 0" class="table-responsive">
        <table class="table table-striped table-bordered align-middle">
          <thead class="bg-secondary text-white">
            <tr>
              <th style="width:48px;"></th>
              <th>Category</th>
              <th>Location</th>
              <th>City</th>
              <th>State</th>
              <th>Sales Rep</th>
              <th>Total Cash In</th>
              <th>Total Cash Out</th>
              <th>Total Net</th>
              <th>Days Active</th>
              <th>Board Count</th>
              <th>Cash In/Day</th>
              <th>Net/Day</th>
              <th>Compared $/Day</th>
            </tr>
            <tr class="bg-light text-dark">
              <th></th>
              <th><input class="form-control" [(ngModel)]="filtersLocation.category" (input)="applyLocationFilters()" placeholder="Filter" /></th>
              <th><input class="form-control" [(ngModel)]="filtersLocation.locationName" (input)="applyLocationFilters()" placeholder="Filter" /></th>
              <th><input class="form-control" [(ngModel)]="filtersLocation.city" (input)="applyLocationFilters()" placeholder="Filter" /></th>
              <th><input class="form-control" [(ngModel)]="filtersLocation.state" (input)="applyLocationFilters()" placeholder="Filter" /></th>
              <th><input class="form-control" [(ngModel)]="filtersLocation.salesRepName" (input)="applyLocationFilters()" placeholder="Filter" /></th>
              <th colspan="8"></th>
            </tr>
          </thead>

          <tbody>
            <ng-container *ngFor="let loc of locationStats; trackBy: trackByLocationId">
              <!-- parent row -->
              <tr>
                <td>
                  <button class="btn btn-sm btn-outline-secondary"
                          (click)="toggleLocation($any(loc).locationId)">
                    {{ expandedLocations.has($any(loc).locationId) ? '▾' : '▸' }}
                  </button>
                </td>
                <td>{{ loc.performanceCategory }}</td>
                <td>{{ loc.locationName }}</td>
                <td>{{ loc.city }}</td>
                <td>{{ loc.state }}</td>
                <td>{{ loc.salesRepName }}</td>
                <td>{{ loc.totalCashIn | number }}</td>
                <td>{{ loc.totalCashOut | number }}</td>
                <td>{{ loc.totalNet | number }}</td>
                <td>{{ loc.daysActive }}</td>
                <td>{{ loc.boardCount }}</td>
                <td>{{ loc.cashInPerDay | number:'1.2-2' }}</td>
                <td>{{ loc.netPerDay | number:'1.2-2' }}</td>
                <td>{{ loc.comparisonAverage | number:'1.2-2' }}</td>
              </tr>

              <!-- child history -->
              <ng-container *ngIf="$any(loc).locationId as locId">
                <tr *ngIf="expandedLocations.has(locId)">
                  <td colspan="14">
                    <div *ngIf="loadingLocationSegs.has(locId)" class="text-muted">
                      Loading history…
                    </div>

                    <ng-container *ngIf="!loadingLocationSegs.has(locId)">
                      <div *ngIf="(locationSegs[locId] || []).length === 0" class="text-muted">
                        No reads in this window.
                      </div>

                      <ng-container *ngIf="$any(loc).locationId as locId">
                        <ng-container *ngIf="$any(loc).locationId as locId">
                          <tr *ngIf="expandedLocations.has(locId)">
                            <td colspan="14">
                              <div *ngIf="loadingLocationSegs.has(locId)" class="text-muted">Loading history…</div>

                              <ng-container *ngIf="!loadingLocationSegs.has(locId)">
                                <div *ngIf="(locationSegs[locId] || []).length === 0" class="text-muted">No reads in this window.</div>

                                <div *ngIf="(locationSegs[locId] || []).length > 0" class="table-responsive">
                                  <table class="table table-sm table-bordered mb-2">
                                    <thead class="table-secondary">
                                      <tr>
                                        <th>Seg #</th>
                                        <th>Date</th>
                                        <th>Total Cash In</th>
                                        <th>Total Cash Out</th>
                                        <th>Total Net</th>
                                        <th>Days Active</th>
                                        <th>Board Count</th>
                                        <th>Cash In/Day</th>
                                        <th>Net/Day</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr *ngFor="let s of locationSegs[locId]">
                                        <td>{{ s.segIdx }}</td>
                                        <td>{{ s.segStart }} – {{ s.segEnd }}</td>
                                        <td>{{ s.cashIn | number }}</td>
                                        <td>{{ s.cashOut | number }}</td>
                                        <td>{{ s.net | number }}</td>
                                        <td>{{ s.spanDays }}</td>
                                        <td>{{ loc.boardCount }}</td>
                                        <td>{{ (s.spanDays && loc.boardCount ? s.cashIn / (s.spanDays * loc.boardCount) : 0) | number:'1.2-2' }}</td>
                                        <td>{{ (s.spanDays && loc.boardCount ? s.net    / (s.spanDays * loc.boardCount) : 0) | number:'1.2-2' }}</td>
                                      </tr>

                                      <tr class="table-light" *ngIf="locationSegs[locId] as segs">
                                        <ng-container *ngIf="sumSegments(segs) as t">
                                          <td colspan="2"><strong>Totals</strong></td>
                                          <td><strong>{{ t.cashIn | number }}</strong></td>
                                          <td><strong>{{ t.cashOut | number }}</strong></td>
                                          <td><strong>{{ t.net | number }}</strong></td>
                                          <td><strong>{{ t.spanDays }}</strong></td>
                                          <td><strong>{{ loc.boardCount }}</strong></td>
                                          <td><strong>{{ (t.spanDays && loc.boardCount ? t.cashIn / (t.spanDays * loc.boardCount) : 0) | number:'1.2-2' }}</strong></td>
                                          <td><strong>{{ (t.spanDays && loc.boardCount ? t.net    / (t.spanDays * loc.boardCount) : 0) | number:'1.2-2' }}</strong></td>
                                        </ng-container>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <small class="text-muted">* Date = segment start–end within the selected {{days}}-day window.</small>
                                </div>
                              </ng-container>
                            </td>
                          </tr>
                        </ng-container>
                      </ng-container>

                    </ng-container>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
          </tbody>

        </table>
      </div>
    </div>
  </div>
</div>
